import ReactModal from 'react-modal'
import { ModalCloseButton } from './ModalCloseButton'
import { MouseEventHandler } from 'react'

export const Modal = ({
    onClose,
    onConfirm,
    onCancel,
    btnConfirmLabel = 'Confirmar',
    btnCancelLabel = 'Cancel',
    children,
    ...modalProps
}: ModalProps) => {
    return (
        <ReactModal
            onRequestClose={onClose}
            {...modalProps}
            style={{
                overlay: {
                    backgroundColor: '#000000bd',
                },
                content: {
                    width: 500,
                    height: 'fit-content',
                    inset: '50%',
                    transform: 'translate(-50%, -50%)',
                },
                ...modalProps.style,
            }}
        >
            <ModalCloseButton onClose={onClose} />
            {children}
            {(onConfirm || onCancel) && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '2em',
                        marginTop: '2em',
                    }}
                >
                    {onCancel && (
                        <button className="outlined" onClick={onCancel}>
                            {btnCancelLabel}
                        </button>
                    )}
                    {onConfirm && (
                        <button className="action" onClick={onConfirm}>
                            {btnConfirmLabel}
                        </button>
                    )}
                </div>
            )}
        </ReactModal>
    )
}

export type ModalProps = ReactModal.Props & {
    onClose: () => void
    onConfirm?: MouseEventHandler<HTMLButtonElement>
    btnConfirmLabel?: string
    onCancel?: MouseEventHandler<HTMLButtonElement>
    btnCancelLabel?: string
}
